var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-eternity-tab__header"},[_c('span',{staticClass:"c-eternity-tab__eternity-points"},[_vm._v(_vm._s(_vm.format(this.eternityPoints, 2)))])])}
var staticRenderFns = []

export { render, staticRenderFns }